module.exports = __webpack_public_path__ + "img/FotoGrinsen.2a132451.svg";